export function getLineTotals ( lineItems ) {
    return lineItems.reduce( ( acc, next ) => {
        const price = toAnalyticsNumber( next.price, 0 );
        const quantity = toAnalyticsNumber( next.quantity, 1 );

        acc += price * (quantity || 1);
        return acc;
    }, 0 );
}

const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const PHONE_PATTERN = /(?:\+?\d{1,3}[\s.-]?)?(?:\(\d{2,4}\)|\d{2,4})[\s.-]\d{3,4}[\s.-]\d{3,4}\b/g;
const LONG_DIGIT_PATTERN = /\d{6,}/g;

export function normalizeSearchTerm ( value ) {
    return String( value || '' )
        .toLowerCase()
        .replace( EMAIL_PATTERN, ' ' )
        .replace( PHONE_PATTERN, ' ' )
        .replace( LONG_DIGIT_PATTERN, ' ' )
        .trim()
        .replace( /\s+/g, ' ' );
}

export function toAnalyticsNumber ( value, fallback = null ) {
    if ( value === '' || value === null || value === undefined ) {
        return fallback;
    }

    const parsedValue = Number( value );
    return Number.isFinite( parsedValue ) ? parsedValue : fallback;
}

export function toAnalyticsInteger ( value, fallback = null ) {
    const parsedValue = toAnalyticsNumber( value, fallback );
    return Number.isFinite( parsedValue ) ? Math.trunc( parsedValue ) : fallback;
}

const ISO_4217_CURRENCY_CODES = new Set( (
    'AED AFN ALL AMD ANG AOA ARS AUD AWG AZN BAM BBD BDT BGN BHD BIF BMD BND BOB BOV BRL ' +
    'BSD BTN BWP BYN BZD CAD CDF CHE CHF CHW CLF CLP CNY COP COU CRC CUC CUP CVE CZK DJF ' +
    'DKK DOP DZD EGP ERN ETB EUR FJD FKP GBP GEL GHS GIP GMD GNF GTQ GYD HKD HNL HTG HUF ' +
    'IDR ILS INR IQD IRR ISK JMD JOD JPY KES KGS KHR KMF KPW KRW KWD KYD KZT LAK LBP LKR ' +
    'LRD LSL LYD MAD MDL MGA MKD MMK MNT MOP MRU MUR MVR MWK MXN MXV MYR MZN NAD NGN NIO ' +
    'NOK NPR NZD OMR PAB PEN PGK PHP PKR PLN PYG QAR RON RSD RUB RWF SAR SBD SCR SDG SEK SGD ' +
    'SHP SLE SOS SRD SSP STN SVC SYP SZL THB TJS TMT TND TOP TRY TTD TWD TZS UAH UGX USD ' +
    'USN UYI UYU UYW UZS VED VES VND VUV WST XAF XAG XAU XBA XBB XBC XBD XCD XCG XDR XOF ' +
    'XPD XPF XPT XSU XTS XUA XXX YER ZAR ZMW ZWG'
).split( ' ' ) );

export function normalizeAnalyticsCurrency ( value ) {
    const normalizedValue = String( value || '' ).trim().toUpperCase();
    return ISO_4217_CURRENCY_CODES.has( normalizedValue ) ? normalizedValue : null;
}

export function getAnalyticsCurrency ( items = [], explicitCurrency ) {
    const normalizedItems = Array.isArray( items ) ? items : [items];
    const configuredCurrency = typeof window !== 'undefined' && window.upi && window.upi.conf
        ? window.upi.conf.currency
        : null;
    const candidates = [
        explicitCurrency,
        ...normalizedItems.reduce( ( currencies, item = {} ) => currencies.concat( [
            item.currency,
            item.currencyCode
        ] ), [] ),
        configuredCurrency
    ];

    return candidates.map( normalizeAnalyticsCurrency ).find( currency => currency !== null );
}
